import React, { useState, useEffect } from "react";
import BaseModalAnimated from "../../components/modal/BaseModalAnimated";
import CustomButton from "../../components/form/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { showFormErrors } from "../../helpers/showFormErrors";
import CustomInput from "../../components/form/CustomInput";
import { departmentsResource, sellersResource, superDepartmentsResource } from "../../helpers/configRoutes/backend_helper";
import { reset_department } from "../../store/departments/action";
import { FileInput } from "lucide-react";

const ModalNewSeller = ({ modal, setModal, filters, setFilters }) => {
    const dispatch = useDispatch()

    const { department, validations } = useSelector((state) => state.Department)
    
    const [loading, setLoading] = useState(false);
    const [superDepartments, setSuperDepartments] = useState([]);

    const validation = useFormik({
        initialValues: department,
        validationSchema: Yup.object().shape({
            ...validations
        }),
        onSubmit: async (values, { setErrors }) => {
            setLoading(true);
            const response = await departmentsResource((values.id ? 'put' : 'post'), values, values.id)
            if (response.status) {
                setFilters({ ...filters })
                dispatch(reset_department())
                setModal({ ...modal, show: false })
            }
            setLoading(false);
        }
    });

    useEffect(() => {
        const getCatalogs = async () => {
            const response = await superDepartmentsResource('get', { params: { select: true } });
            setSuperDepartments(response.clients);
        };
        getCatalogs();
    }, []);


    return (
        <BaseModalAnimated setModal={setModal} modal={modal}>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    showFormErrors(validation);
                    return false;
                }}
            >
                <div className="px-6 py-5 space-y-6 bg-fr-light text-fr-dark">
                    <h2 className="text-lg font-semibold text-center">
                        {department.id ? "Editar departamento" : "Crear departamento"}
                    </h2>

                    {/* Inputs: 2 en fila + 1 debajo */}

                    <CustomInput
                        label={"Nombre"}
                        type="text"
                        name="name"
                        error={validation?.errors?.name}
                        value={validation?.values?.name}
                        handleChange={validation.handleChange}
                        className="text-sm"
                    />

                    <CustomInput
                        label={"Identificador de departamento"}
                        type="text"
                        name="code"
                        error={validation?.errors?.code}
                        value={validation?.values?.code}
                        handleChange={validation.handleChange}
                        className="text-sm"
                    />

                </div>

                <div className="px-6 py-4 bg-fr-secondary border-t border-fr-muted flex justify-end gap-3 rounded-b-lg">
                    <CustomButton
                        loading={loading}
                        textLoad="Guardando"
                        className="bg-fr-primary hover:bg-fr-primary-hover text-fr-light px-6 py-2 rounded-lg text-sm transition-all shadow"
                        type="submit"
                    >
                        Guardar
                    </CustomButton>

                    <CustomButton
                        className="bg-fr-danger hover:bg-red-600 text-fr-light px-6 py-2 rounded-lg text-sm transition-all shadow"
                        onClick={() => setModal({ ...modal, show: false })}
                        type="button"
                    >
                        Cancelar
                    </CustomButton>
                </div>
            </form>

        </BaseModalAnimated>
    );
};

export default ModalNewSeller;
